import React from "react";
// @ts-ignore
import { Link } from 'react-router-dom'
import { getLibraryURL } from "src/utils/get-simulation-library-url";

export default function CiReviewsHeader(props) {
    return (
        <>
            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 100%;
                `}>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        CI reviews
                    </div>
                    <div css={` 
                        font-size:16px;
                        color:#2E2E38;
                        margin-top:12px;
                        `}>
                        <span>
                            Following reviews are created by the API.
                        </span>
                    </div>
                    <div css="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    ">
                        <div css={` 
                        margin-top:12px;
                        `}>
                            <Link to="/my-reviews">Go to my reviews</Link>
                        </div>
                        {
                            props.review ?
                                <div css={` 
                                    margin-top:12px;
                                `}>
                                    <Link to={getLibraryURL({
                                        engagement_id: props.review.engagementData._id,
                                        review_id: props.review._id
                                    })}>Go to parent review simulations</Link>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}